import {Button, Card, CardActions, CardContent, Modal, TextField, Theme, Typography} from '@material-ui/core';
import {makeStyles} from '@material-ui/styles';
import clsx from 'clsx';
import React, {useState} from 'react';
import {T} from 'react-polyglot-hooks';
import PerfectScrollbar from 'react-perfect-scrollbar';

const useStyles = makeStyles((theme: Theme) => ({
    root: {
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        border: '1px solid #6101AD',
        borderRadius: 3,
        boxShadow: theme.shadows[20],
        width: 700,
        maxHeight: '95%',
        overflowY: 'auto',
        maxWidth: '90%'
    },
    actions: {
        justifyContent: 'flex-end'
    },
}));

const InfoModal = (props: {
    className?: string,
    onClose?: () => void,
    open: boolean,
    title: string,
    body?: string,
    onSigned?: (signature: string) => void,
    action?: React.ReactNode;
}) => {
    const {open, onClose, title, body, onSigned, action, ...rest} = props;
    const classes = useStyles();
    const [signature, setSignature] = useState('');

    if (!open) {
        return null;
    }

    return (
        <Modal onClose={onClose} open={open}>
            <Card {...rest} className={clsx(classes.root)}>
                <CardContent>
                    <Typography gutterBottom variant="h3">{title}</Typography>

                    {body && (
                        <PerfectScrollbar>
                            <Typography gutterBottom variant="body1" dangerouslySetInnerHTML={{__html: body}}/>
                        </PerfectScrollbar>
                    )}

                    {onSigned && (
                        <TextField
                            fullWidth
                            label="Sign (type name)"
                            name="signature"
                            onChange={(event) => setSignature(event.target.value)}
                            error={!(signature && signature.length > 0)}
                            // @ts-ignore
                            helperText={(signature && signature.length > 0) ? '' : 'Please sign'}
                            InputLabelProps={{
                                shrink: true,
                            }}
                            value={signature}
                        />
                    )}

                </CardContent>
                <CardActions className={classes.actions}>
                    {onClose && (
                        <Button onClick={onClose} variant="contained">
                            <T phrase="Close"/>
                        </Button>
                    )}
                    {onSigned && (
                        <Button onClick={() => {
                            if (onClose) onClose();
                            onSigned(signature);
                        }} variant="contained" disabled={!(signature && signature.length > 0)}>
                            <T phrase="Sign & Continue"/>
                        </Button>
                    )}
                    {action}
                </CardActions>
            </Card>
        </Modal>
    );
};

export default InfoModal;
